export const CARRIER_ASENDIA = 'asendia';
export const CARRIER_AUSPOST = 'auspost';
export const CARRIER_CANADA_POST = 'canada_post';
export const CARRIER_DHL_ECOMMERCE = 'dhl_ecommerce';
export const CARRIER_DHL = 'dhl';
export const CARRIER_FEDEX = 'fedex';
export const CARRIER_NINJA_VAN = 'ninja_van';
export const CARRIER_PCF = 'pcf';
export const CARRIER_PUROLATOR = 'purolator';
export const CARRIER_ROYALMAIL = 'royalmail';
export const CARRIER_SEKO = 'seko';
export const CARRIER_PICKUP = 'pickup';
export const CARRIER_SWISSPOST = 'swisspost';
export const CARRIER_UPS = 'ups';
export const CARRIER_USPS = 'usps';
export const CARRIER_CNE = 'cne';
export const CARRIER_YANWEN = 'yanwen';

export function findCarrierByShippingMethod(shippingMethod) {
  return Object.keys(ShippingMethodsByCarrier).find((carrier) =>
    Object.keys(ShippingMethodsByCarrier[carrier]).find(
      (key) => ShippingMethodsByCarrier[carrier][key] === shippingMethod,
    ),
  );
}

export const Carriers = {
  ASENDIA: CARRIER_ASENDIA,
  AUSPOST: CARRIER_AUSPOST,
  CANADA_POST: CARRIER_CANADA_POST,
  DHL_ECOMMERCE: CARRIER_DHL_ECOMMERCE,
  DHL: CARRIER_DHL,
  FEDEX: CARRIER_FEDEX,
  NINJA_VAN: CARRIER_NINJA_VAN,
  PCF: CARRIER_PCF,
  PUROLATOR: CARRIER_PUROLATOR,
  ROYALMAIL: CARRIER_ROYALMAIL,
  SEKO: CARRIER_SEKO,
  PICKUP: CARRIER_PICKUP,
  SWISSPOST: CARRIER_SWISSPOST,
  UPS: CARRIER_UPS,
  USPS: CARRIER_USPS,
  CNE: CARRIER_CNE,
  YANWEN: CARRIER_YANWEN,
};

export const CarriersDisplayName = {
  [CARRIER_ASENDIA]: 'Asendia',
  [CARRIER_AUSPOST]: 'AusPost',
  [CARRIER_CANADA_POST]: 'Canada Post',
  [CARRIER_DHL_ECOMMERCE]: 'DHL ECommerce',
  [CARRIER_DHL]: 'DHL',
  [CARRIER_FEDEX]: 'FedEx',
  [CARRIER_NINJA_VAN]: 'Ninja Van',
  [CARRIER_PCF]: 'PCF',
  [CARRIER_PUROLATOR]: 'Purolator',
  [CARRIER_ROYALMAIL]: 'RoyalMail',
  [CARRIER_SEKO]: 'Seko',
  [CARRIER_PICKUP]: 'Pickup',
  [CARRIER_SWISSPOST]: 'SwissPost',
  [CARRIER_UPS]: 'UPS',
  [CARRIER_USPS]: 'USPS',
  [CARRIER_CNE]: 'CNE',
  [CARRIER_YANWEN]: 'Yanwen',
};

export const ShippingMethodsByCarrier = {
  [CARRIER_ASENDIA]: {
    elite: 'ASENDIA_ELITE',
    plus: 'ASENDIA_PLUS',
    select: 'ASENDIA_SELECT',
    standard: 'ASENDIA_STANDARD',
  },
  [CARRIER_AUSPOST]: {
    express_post: 'AUSPOST_EXPRESS_POST',
  },
  [CARRIER_CANADA_POST]: {
    expedited: 'CANADAPOST_EXPEDITED',
    priority: 'CANADAPOST_PRIORITY',
    regular: 'CANADAPOST_REGULAR',
    xpress: 'CANADAPOST_XPRESS',
  },
  [CARRIER_CNE]: {
    ground: 'CNE_GROUND',
  },
  [CARRIER_DHL_ECOMMERCE]: {
    ecommerce: 'DHL_ECOMMERCE',
  },
  [CARRIER_DHL]: {
    express: 'DHL_EXPRESS',
    'smartmail expedited': 'DHL_SMARTMAIL_EXPEDITED',
    'smartmail expedited max': 'DHL_SMARTMAIL_EXPEDITED_MAX',
    'smartmail ground': 'DHL_SMARTMAIL_GROUND',
  },
  [CARRIER_FEDEX]: {
    '2nd day': 'FEDEX_2_DAY',
    '2nd day early': 'FEDEX_2_DAY_AM',
    'express saver': 'FEDEX_EXPRESS_SAVER',
    'first overnight': 'FEDEX_FIRST_OVERNIGHT',
    ground: 'FEDEX_GROUND',
    'home delivery': 'FEDEX_HOME_DELIVERY',
    'priority overnight': 'FEDEX_PRIORITY_OVERNIGHT',
    sameday: 'FEDEX_SAMEDAY',
    smartpost: 'FEDEX_SMART_POST',
    'standard overnight': 'FEDEX_STANDARD_OVERNIGHT',
  },
  [CARRIER_NINJA_VAN]: {
    'home delivery': 'NINJA_VAN_HOME_DELIVERY',
  },
  [CARRIER_PCF]: {
    standard: 'PCF_STANDARD',
  },
  [CARRIER_PUROLATOR]: {
    express: 'PUROLATOR_EXPRESS',
    ground: 'PUROLATOR_GROUND',
  },
  [CARRIER_ROYALMAIL]: {
    tracked: 'ROYAL_MAIL_TRACKED_24_48',
  },
  [CARRIER_SEKO]: {
    international: 'SEKO_INTERNATIONAL',
  },
  [CARRIER_PICKUP]: {
    'store pickup': 'STORE_PICKUP',
  },
  [CARRIER_SWISSPOST]: {
    economy: 'SWISSPOST_ECONOMY',
    express: 'SWISSPOST_EXPRESS',
    priority: 'SWISSPOST_PRIORITY',
  },
  [CARRIER_UPS]: {
    'Next Day Air': 'UPS_1DA',
    'Next Day Air Early AM': 'UPS_1DM',
    'Next Day Air Saver': 'UPS_1DP',
    '2nd Day Air': 'UPS_2DA',
    '2nd Day Air AM': 'UPS_2DM',
    '3 Day Select': 'UPS_3DS',
    ground: 'UPS_GND',
    SurePost: 'UPS_SP',
  },
  [CARRIER_USPS]: {
    'first class mail': 'USPS_FIRST_CLASS_MAIL',
    'priority express mail': 'USPS_PRIORITY_EXPRESS_MAIL',
    'priority mail': 'USPS_PRIORITY_MAIL',
    'retail ground': 'USPS_RETAIL_GROUND',
  },
  [CARRIER_YANWEN]: {
    'express ground': 'YANWEN_GROUND',
  },
};
